import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { Fragment, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { setNavIndex } from "../../../../secured-app/uiSlice";
import MaskedCvv from "../../billpay/payment_details/masked_cvv_input";
import { fetchCC, setErrors } from "../topupSlice";
import SelectCC from "./select_card";

const useStyles = makeStyles((theme) => ({
  root: { marginBottom: theme.spacing(2) },
  formControl: {
    marginBottom: theme.spacing(2),
  },
  addBtn: {
    borderRadius: 20,
  },
}));

function PaymentDetailsRegistered(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    setPaymentDetails,
    paymentDetailsState,
    handleValidateNext,
    invalidateStep = { invalidateStep },
  } = props;
  const [paymentDetails, updatePaymentDetails] = useState(paymentDetailsState);
  const [errors, updateErrors] = useState({
    customerCardId: "",
    cvv: "",
  });
  const { cCards } = useSelector((state) => state.topup);
  const handleChange = (prop) => (event) => {
    let isEmpty = false;
    if (paymentDetails.customerCardId <= 0 && paymentDetails.cvv === "") {
      isEmpty = true;
    }

    let value = event.target.value
    updatePaymentDetails({ ...paymentDetails, [prop]: value });
    setPaymentDetails({ ...paymentDetails, [prop]: value });

    const newErrors = {
      customerCardId: "",
      cvv: "",
    };

    if (prop === "customerCardId") {
      newErrors.customerCardId = "";

      if (value === 0) {
        newErrors.customerCardId = "Must select a payment method";
      }
    } else if (prop === "cvv") {
      newErrors.cvv = "";

      if (value === "") {
        newErrors.cvv = "CVV cannot be empty";
      } else if (value.length < 3) {
        newErrors.cvv = "CVV must be exactly 3 digits";
      }
    }

    updateErrors({ ...newErrors });
    dispatch(setErrors({ ...newErrors }));
    if (!isEmpty) {
      handleValidateNext();
    }
  };

  useEffect(() => {
    async function fetchCards() {
      await dispatch(fetchCC());
    }

    fetchCards();
  }, [dispatch]);

  const handleClick = () => {
    dispatch(setNavIndex(4));
  };

  return (
    <Fragment>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <SelectCC
            cards={cCards}
            handleChange={handleChange}
            error={errors.customerCardId}
            value={paymentDetails.customerCardId}
          />
        </Grid>
        <Grid item xs={12}>
          <MaskedCvv
            handleChange={handleChange}
            value={paymentDetails.cvv}
            error={errors.cvv}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  paymentDetailsState: state.topup.paymentDetails,
  errors: state.topup.errors,
  cCards: state.topup.cCards,
});

const mapDispatch = {};

export default connect(mapStateToProps, mapDispatch)(PaymentDetailsRegistered);
